angular.module("componentes").factory("vertownNotificationAccessService", [
	"$http",
	"accountService",
	function ($http, accountService) {
		"use strict";

		const baseApiRoute = Vgr.constants.sharedServicesHostUrl + Vgr.resources.sharedServices.notifications;

		const _listNotifications = function () {
			const organizationId = accountService.getCurrentClient().organization.id;
			const organizationUnitCode = accountService.getCurrentClient().code;

			const baseUrl = baseApiRoute
				.replace("[ORGANIZATION_ID]", organizationId)
				.replace("[ORGANIZATION_UNIT]", organizationUnitCode);

			const req = {
				method: "get",
				url: `${baseUrl}?onlyActives=true`
			};
			return $http(req);
		};

		return {
			listNotifications: _listNotifications
		};
	}
]);
